import { render, staticRenderFns } from "./KommunetorgetStandardPage.vue?vue&type=template&id=efa62a78&"
import script from "./KommunetorgetStandardPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetStandardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa62a78')) {
      api.createRecord('efa62a78', component.options)
    } else {
      api.reload('efa62a78', component.options)
    }
    module.hot.accept("./KommunetorgetStandardPage.vue?vue&type=template&id=efa62a78&", function () {
      api.rerender('efa62a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetStandardPage.vue"
export default component.exports